import angular from 'angular';
import 'angular-bootstrap';
import 'leaflet';
import 'leaflet-draw';
import locales from '../../locale';
import './ssoServices';
import 'Leaflet.Snap';
import '../../../scripts/leaflet-label-shim';

const ssoControllers = angular.module('applicationModule.ssoControllers', [
    'applicationModule.ssoServices',
    'commonModule.localizationMapService',
    'ui.bootstrap'
]);

// SSO Controller
ssoControllers.controller('SSOController', ['$scope', '$rootScope', '$state', '$stateParams', 'SSO', 'NgTableParams', 'growl', 'AppsoupAPI', 'Permissions', function ($scope, $rootScope, $state, $stateParams, SSO, NgTableParams, growl, AppsoupAPI, Permissions) {
    'use strict';

    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $scope.writeAccess = Permissions.hasWriteAccess('sso');
    $scope.application_id = $stateParams.application_id;
    $scope.sso = {};
    $scope.isLoading = true;

    SSO.get($scope.application_id)
        .then(function (result) {
            let data = result.data;

            if (data.success) {
                $scope.sso = data.sso;
            } else {
                growl.error('MODULES.SSO.ERROR.' + data.error);
            }
        })
        .finally(function () {
            $scope.isLoading = false;
            $rootScope.doingResolve = false;
        });

    if ($scope.writeAccess) {
        $scope.save = function () {
            $scope.isLoading = true;
            $scope.sso.app_id = $scope.application_id;
            SSO.save($scope.sso)
                .then(function (result) {
                    let data = result.data;

                    if (data.success) {
                        growl.success('MODULES.SSO.SUCCESS.SAVED');
                    } else {
                        growl.error('MODULES.SSO.ERROR.SAVED');
                    }
                })
                .finally(function () {
                    $scope.isLoading = false;
                });
        };
    }
}]);

export default ssoControllers;
